import { createContext, useContext } from 'react';
import type { WixPatternsContainerParams } from '../state';

const Context = createContext<Partial<WixPatternsContainerParams>>({});

export const WixPatternsContainerOverridesContext = Context;
export const WixPatternsContainerOverridesProvider = Context.Provider;
export const WixPatternsContainerOverridesConsumer = Context.Consumer;
export const useWixPatternsContainerOverrides = () => useContext(Context);
